import React, { useState } from 'react';
import PricingCompaniesPanel from './PricingCompaniesPanel';
import PricingAdvisorsPanel from './PricingAdvisorsPanel';
import PricingInvestorsPanel from './PricingInvestorsPanel';

const PERSONAS = [
    { key: 'companies', label: 'Companies' },
    { key: 'advisors', label: 'Advisors' },
    { key: 'investors', label: 'Investors' },
];

const PricingTabsSection = () => {
    const [persona, setPersona] = useState('companies');

    return (
        <>
            <div className="lp-pricing-tabbar">
                <div className="lp-pricing-tabbar-inner" role="tablist">
                    {PERSONAS.map(p => (
                        <button key={p.key} className={`lp-pricing-tab ${persona === p.key ? 'is-active' : ''}`} role="tab" aria-selected={persona === p.key} onClick={() => setPersona(p.key)}>{p.label}</button>
                    ))}
                </div>
            </div>

            <div style={{ display: persona === 'companies' ? 'block' : 'none' }}><PricingCompaniesPanel /></div>
            <div style={{ display: persona === 'advisors' ? 'block' : 'none' }}><PricingAdvisorsPanel /></div>
            <div style={{ display: persona === 'investors' ? 'block' : 'none' }}><PricingInvestorsPanel /></div>
        </>
    );
};

export default PricingTabsSection;
